<template>
  <div class="m-0 dbozone-font bg-mafiaways2" :class="`${lang}-font`">
    <div class="container d-flex flex-column justify-content-center">
      <div class="d-flex flex-column highlight-red">
        <section class="d-flex p-2 justify-content-center align-items-center">
          <h5 class="font-weight-bold m-0 text-title " :class="`-${lang} -mafiaways2`">{{ $t('mafiaways2.name') }}</h5>
        </section>
      </div>

      <div class="pt-5 pb-3">
        <div class="p-4 justify-content-center align-items-center highlight-gray">
          <h3 class="m-0 text-title-bold" :class="`-${lang}`">{{ $t('mafiaways2.gamerule') }}</h3>
        </div>
      </div>


      <div class="d-flex p-2 mt-1" v-for="(text, index) in textList" :key="'textList' + index">
        <div v-if="index === 0">
          <div v-if="lang === 'zh'" class="">
            <span class="m-0 text-sub" :class="`-${lang}`">{{ $t(text) }}</span>
          </div>
          <div v-else class="">
            <span class="m-0 text-sub" :class="`-${lang}`">{{ $t(text) }}</span>
          </div>
        </div>
        <div v-else>
          <span v-if="index === 1" class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t(text) }}
            {{ currencyFormatterWithSymbol(betMinMax[0]) }}</span>
          <span v-else-if="index === 2" class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t(text) }}
            {{ currencyFormatterWithSymbol(betMinMax[1]) }}</span>
          <span v-else-if="index === 3" class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t(text) + baseBet +
            $t('mafiaways2.text-rule5') }} </span>
          <span v-else-if="index === 4" class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t(text) +
            currencyFormatterWithSymbol(betMinMax[0])
            + $t('info.to') + currencyFormatterWithSymbol(betMinMax[1]) +
            $t('mafiaways2.text-rule7') }} </span>
          <span v-else-if="index === 5" class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t(text) + currency +
            `(` +
            formattedCurrency + `)` }}</span>
          <span v-else-if="index > 5" class="m-0 text-sub p-4" :class="`-${lang}`">{{ $t(text) }}</span>
        </div>
      </div>

      <div class="pt-5 pb-3">
        <div class="p-4 justify-content-center align-items-center highlight-gray">
          <h3 class="m-0 text-title-bold">{{ $t('mafiaways2.round') }}</h3>
        </div>
      </div>

      <div class="d-flex p-2 mt-1 pb-3" v-for="(text, index) in roundList" :key="'roundList' + index">
        <div>
          <span v-if="index === 0" class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t(text) }}</span>
          <span v-if="index === 1" class="m-0 text-bold" :class="`-${lang}`">{{ $t('mafiaways2.round-title1')
          }}</span>
          <span v-if="index === 1" class="m-0 text-sub" :class="`-${lang}`">{{ $t(text) }}</span>
          <span v-if="index === 2" class="m-0 text-bold" :class="`-${lang}`">{{ $t('mafiaways2.round-title2')
          }}</span>
          <span v-if="index === 2" class="m-0 text-sub" :class="`-${lang}`">{{ $t(text) }}</span>
          <span v-if="index === 3" class="m-0 text-bold" :class="`-${lang}`">{{ $t('mafiaways2.round-title3')
          }}</span>
          <span v-if="index === 3" class="m-0 text-sub" :class="`-${lang}`">{{ $t(text) }}</span>
          <span v-if="index === 4" class="m-0 text-bold" :class="`-${lang}`">{{ $t('mafiaways2.round-title4')
          }}</span>
          <span v-if="index === 4" class="m-0 text-sub" :class="`-${lang}`">{{ $t(text) }}</span>
          <div v-if="index === 5" class="m-0 text-bold" :class="`-${lang}`">{{ $t('mafiaways2.round-title5')
          }}</div>
          <span v-if="index === 5" class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t(text) }}</span>
          <span v-if="index === 6" class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t(text) }}</span>
          <span v-if="index === 7" class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t(text) }}</span>
          <span v-if="index === 8" class="m-0 text-bold" :class="`-${lang}`">{{ $t('mafiaways2.round-title6')
          }}</span>
          <span v-if="index === 8" class="m-0 text-sub " :class="`-${lang}`">{{ $t(text) }}</span>
        </div>
      </div>

      <div class="pt-3 pb-4">
        <div class="p-4 justify-content-center align-items-center highlight-gray">
          <h3 class="m-0 text-title-bold">{{ $t('mafiaways2.paytable') }}</h3>
        </div>
      </div>

      <div>
        <span class="m-0 text-sub pl-3">{{ $t('mafiaways2.paytable-des') }}</span>
      </div>

      <div class="col-12 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/mafiaways2/symbol_7.png`)" alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center">
          <span class="text-sub-payout" :class="`-${lang}`">
            {{ '5 - ' + decimalFormat(currentBet * paytable[7][4] / baseBet) }}<br>
            {{ '4 - ' + decimalFormat(currentBet * paytable[7][3] / baseBet) }}<br>
            {{ '3 - ' + decimalFormat(currentBet * paytable[7][2] / baseBet) }}
          </span>
        </div>
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/mafiaways2/symbol_6.png`)" alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center">
          <span class="text-sub-payout" :class="`-${lang}`">
            {{ '5 - ' + decimalFormat(currentBet * paytable[6][4] / baseBet) }}<br>
            {{ '4 - ' + decimalFormat(currentBet * paytable[6][3] / baseBet) }}<br>
            {{ '3 - ' + decimalFormat(currentBet * paytable[6][2] / baseBet) }}
          </span>
        </div>
      </div>
      <div class="col-12 mt-3 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/mafiaways2/symbol_5.png`)" alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center">
          <span class="text-sub-payout" :class="`-${lang}`">
            {{ '5 - ' + decimalFormat(currentBet * paytable[5][4] / baseBet) }}<br>
            {{ '4 - ' + decimalFormat(currentBet * paytable[5][3] / baseBet) }}<br>
            {{ '3 - ' + decimalFormat(currentBet * paytable[5][2] / baseBet) }}
          </span>
        </div>
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/mafiaways2/symbol_4.png`)" alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center">
          <span class="text-sub-payout" :class="`-${lang}`">
            {{ '5 - ' + decimalFormat(currentBet * paytable[4][4] / baseBet) }}<br>
            {{ '4 - ' + decimalFormat(currentBet * paytable[4][3] / baseBet) }}<br>
            {{ '3 - ' + decimalFormat(currentBet * paytable[4][2] / baseBet) }}
          </span>
        </div>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/mafiaways2/symbol_3.png`)" alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center">
          <span class="text-sub-payout" :class="`-${lang}`">
            {{ '5 - ' + decimalFormat(currentBet * paytable[3][4] / baseBet) }}<br>
            {{ '4 - ' + decimalFormat(currentBet * paytable[3][3] / baseBet) }}<br>
            {{ '3 - ' + decimalFormat(currentBet * paytable[3][2] / baseBet) }}
          </span>
        </div>
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/mafiaways2/symbol_2.png`)" alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center">
          <span class="text-sub-payout" :class="`-${lang}`">
            {{ '5 - ' + decimalFormat(currentBet * paytable[2][4] / baseBet) }}<br>
            {{ '4 - ' + decimalFormat(currentBet * paytable[2][3] / baseBet) }}<br>
            {{ '3 - ' + decimalFormat(currentBet * paytable[2][2] / baseBet) }}
          </span>
        </div>
      </div>
      <div class="col-12 mt-3 justify-content-left d-flex flex-row mt-5">
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/mafiaways2/symbol_1.png`)" alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center">
          <span class="text-sub-payout" :class="`-${lang}`">
            {{ '5 - ' + decimalFormat(currentBet * paytable[1][4] / baseBet) }}<br>
            {{ '4 - ' + decimalFormat(currentBet * paytable[1][3] / baseBet) }}<br>
            {{ '3 - ' + decimalFormat(currentBet * paytable[1][2] / baseBet) }}
          </span>
        </div>
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/mafiaways2/symbol_0.png`)" alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center">
          <span class="text-sub-payout" :class="`-${lang}`">
            {{ '5 - ' + decimalFormat(currentBet * paytable[0][4] / baseBet) }}
            <br>{{ '4 - ' + decimalFormat(currentBet * paytable[0][3] / baseBet) }}
            <br>{{ '3 - ' + decimalFormat(currentBet * paytable[0][2] / baseBet) }}
          </span>
        </div>
      </div>

      <div class="pt-5 pb-4">
        <div class="p-4 justify-content-center align-items-center highlight-gray">
          <h3 class="m-0 text-title-bold ">{{ $t('mafiaways2.adjustment') }}</h3>
        </div>
      </div>

      <div>
        <span class="m-0 text-sub pl-3">{{ $t('mafiaways2.adjustment-des') }}</span>
      </div>

      <div class="pt-5">
        <span class="m-0 text-bold ">{{ $t('mafiaways2.note') }}</span>
        <div class="m-0 text-sub ">{{ $t('mafiaways2.note-des1') }}</div>
        <div class="m-0 text-sub ">{{ $t('mafiaways2.note-des2') }}</div>
      </div>

      <div class="pt-5 pb-3">
        <div class="p-4 justify-content-center align-items-center highlight-gray">
          <h3 class="m-0 text-title-bold">{{ $t('mafiaways2.goldframe') }}</h3>
        </div>
      </div>

      <div class="d-flex p-2 mt-1 justify-content-center">
        <img class="mt-3 icon-symbol" :src="require(`../../assets/paytable/mafiaways2/way.png`)" alt="">
      </div>

      <div class="d-flex p-2 mt-1" v-for="(text, index) in goldframeList" :key="'goldframeList' + index">
        <div>
          <span class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t(text) }}</span>
        </div>
      </div>

      <div class="pt-5 pb-3">
        <div class="p-4 justify-content-center align-items-center highlight-gray">
          <h3 class="m-0 text-title-bold">{{ $t('mafiaways2.wildsymbol') }}</h3>
        </div>
      </div>

      <div class="d-flex p-2 mt-1" v-for="(text, index) in wildList" :key="'wildList' + index">
        <div>
          <span v-if="index === 0" class="m-0 text-sub pl-3" :class="`-${lang}`">{{ $t(text) }}
            <div class="d-flex p-2 mt-1 justify-content-center">
              <img class="mt-3 icon-symbol" :src="require(`../../assets/resultGame/mafiaways2/symbol_9.png`)" alt="">
            </div>
          </span>
          <span v-else-if="index === 3">
            <span class="m-0 text-bold pl-4" :class="`-${lang}`">{{ $t('mafiaways2.wild-example') }}</span>
            <span class="m-0 text-sub" :class="`-${lang}`">{{ $t(text) }}</span>
          </span>
          <span v-else-if="index === 4">
            <span class="m-0 text-bold pl-4" :class="`-${lang}`">{{ $t('mafiaways2.wild-note') }}</span>
            <span class="m-0 text-sub" :class="`-${lang}`">{{ $t(text) }}</span>
          </span>
          <span v-else class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t(text) }}</span>
        </div>
      </div>

      <div class="pt-5 pb-3">
        <div class="p-4 justify-content-center align-items-center highlight-gray">
          <h3 class="m-0 text-title-bold">{{ $t('mafiaways2.multipliers') }}</h3>
        </div>
      </div>

      <div class="d-flex p-2 mt-1" v-for="(text, index) in multipliersList" :key="'multipliersList' + index">
        <div>
          <span v-if="index === 0">
            <div class="d-flex p-2 mt-1 justify-content-center">
              <img class="mt-3 icon-paytable" :src="require(`../../assets/paytable/mafiaways2/multiplier.png`)" alt="">
            </div>
            <span class="m-0 text-sub pl-3" :class="`-${lang}`">{{ $t(text) }}</span>
          </span>
          <span v-else-if="index === 4">
            <span class="m-0 text-sub" :class="`-${lang}`">{{ $t(text) }}</span>
          </span>
          <span v-else class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t(text) }}</span>
        </div>
      </div>

      <div class="pt-5 pb-3">
        <div class="p-4 justify-content-center align-items-center highlight-gray">
          <h3 class="m-0 text-title-bold">{{ $t('mafiaways2.freespin') }}</h3>
        </div>
      </div>

      <div class="d-flex p-2 mt-1" v-for="(text, index) in freespinFeatureList" :key="'freespinFeatureList' + index">
        <div>
          <span v-if="index === 0">
            <div class="d-flex p-2 mt-1 pb-4 justify-content-center">
              <img class="mt-3 icon-symbol" :src="require(`../../assets/resultGame/mafiaways2/symbol_8.png`)" alt="">
              <img class="mt-3 icon-symbol" :src="require(`../../assets/resultGame/mafiaways2/symbol_8.png`)" alt="">
              <img class="mt-3 icon-symbol" :src="require(`../../assets/resultGame/mafiaways2/symbol_8.png`)" alt="">
            </div>
            <span class="m-0 text-sub pl-3 " :class="`-${lang}`">{{ $t(text) }}</span>
          </span>
          <span v-else-if="index > 4">
            <span class="m-0 text-sub pl-3" :class="`-${lang}`">{{ $t(text) }}</span>
          </span>
          <span v-else class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t(text) }}</span>
        </div>
      </div>

      <div class="pt-5 pb-3">
        <div class="p-4 justify-content-center align-items-center highlight-gray">
          <h3 class="m-0 text-title-bold">{{ $t('mafiaways2.buyfreespin') }}</h3>
        </div>
      </div>

      <div class="d-flex p-2 mt-1" v-for="(text, index) in buyfreespinList" :key="'buyfreespinList' + index">
        <div>
          <span v-if="index === 0">
            <div class="d-flex p-2 mt-1 mb-2 justify-content-center">
              <img class="mt-3 icon-way" :src="require(`../../assets/paytable/mafiaways2/feature_buy_${imgLang}.png`)"
                alt="">
            </div>
            <span class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t(text) }}</span>
          </span>
          <span v-else-if="index === 4" class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t(text)
            + currencyFormatterWithSymbol(betMinMax[0])
            + $t('mafiaways2.buyfreespin-des6') + currencyFormatterWithSymbol(betMinMax[1])
          }}</span>
          <span v-else-if="index === 5" class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t(text)
            + currencyFormatterWithSymbol(betMinMax[1]) + $t('mafiaways2.buyfreespin-des8')
          }}</span>
          <span v-else class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t(text) }}</span>
        </div>
      </div>

      <div class="pt-5 pb-3">
        <div class="p-4 justify-content-center align-items-center highlight-gray">
          <h3 class="m-0 text-title-bold">{{ $t('mafiaways2.way') }}</h3>
        </div>
      </div>

      <div class="d-flex p-2 mt-1" v-for="(text, index) in wayList" :key="'wayList' + index">
        <div>
          <span v-if="index === 1">
            <div class="d-flex p-2 mt-1 mb-2 justify-content-center">
              <img class="mt-3 icon-way" :src="require(`../../assets/paytable/mafiaways2/line_paytable.png`)" alt="">
            </div>
            <span class="m-0 text-sub" :class="`-${lang}`">{{ $t(text) }}</span>
          </span>
          <span v-else class="m-0 pl-4 text-sub" :class="`-${lang}`">{{ $t(text) }}</span>
        </div>
      </div>

      <div class="pt-5 pb-3">
        <div class="p-4 justify-content-center align-items-center highlight-red">
          <h3 class="m-0 text-title-bold">{{ $t('main-game.title') }}</h3>
        </div>
      </div>

      <div class="d-flex pt-5 mt-1 justify-content-left">
        <img class="icon-spin" :src="require(`../../assets/ruleGames/mafiaways2/spin_btn.png`)" alt="">
        <div class="m-0 pl-3">
          <span class="m-0 text-bold">{{ $t('main-game.spin') }}</span>
          <div v-for="(text, index) in spinList" :key="'spinList' + index">
            <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t(text) }}</div>
          </div>
        </div>
      </div>

      <div class="d-flex pt-5 mt-1 justify-content-left">
        <img class="icon-menu" :src="require(`../../assets/ruleGames/mafiaways2/stop_btn.png`)" alt="">
        <div class="m-0 pl-3">
          <div class="m-0 text-sub pl-4\" :class="`-${lang}`">{{ $t('main-game.autospin-rounds-desc1') }}
          </div>
        </div>
      </div>

      <div class="d-flex pt-5 mt-1 justify-content-left">
        <img class="icon-menu" :src="require(`../../assets/ruleGames/mafiaways2/autospin_btn.png`)" alt="">
        <div class="m-0 pl-3">
          <span class="m-0 text-bold">{{ $t('main-game.autospin') }}</span>
          <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t('main-game.text-auto1') }}</div>
          <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t('main-game.text-auto2') }}</div>
        </div>
      </div>

      <div class="d-flex pt-5 mt-1 justify-content-left">
        <img class="icon-menu" :src="require(`../../assets/ruleGames/mafiaways2/menu_btn.png`)" alt="">
        <div class="m-0 pl-3">
          <span class="m-0 text-bold">{{ $t('main-game.additional') }}</span>
          <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t('main-game.additional-des') }}</div>
        </div>
      </div>

      <div class="d-flex pt-5 mt-1 justify-content-left">
        <img class="icon-menu" :src="require(`../../assets/ruleGames/wallet_icon.png`)" alt="">
        <div class="m-0 pl-3">
          <span class="m-0 text-bold">{{ $t('main-game.wallet') }}</span>
          <span class="m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.wallet-des1') }}</span>
          <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t('main-game.wallet-des2') }}</div>
        </div>
      </div>

      <div class="d-flex pt-5 mt-1 justify-content-left">
        <img class="icon-menu" :src="require(`../../assets/ruleGames/main/refresh_icon.png`)" alt="">
        <div class="m-0 pl-3 ">
          <span class="m-0 text-bold">{{ $t('main-game.refresh') }}</span>
          <span class="m-0 text-sub" :class="`-${lang}`">{{ $t('main-game.refresh-des') }}</span>
        </div>
      </div>

      <div class="d-flex pt-5 mt-1 justify-content-left">
        <img class="icon-menu" :src="require(`../../assets/ruleGames/main/betamount_icon.png`)" alt="">
        <div class="m-0 pl-3">
          <span class="m-0 text-bold">{{ $t('main-game.bet-amount') }}</span>
          <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t('main-game.bet-amount-des1') }}</div>
          <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t('main-game.bet-amount-des2') }}</div>
          <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t('main-game.bet-amount-des3') }}</div>
        </div>
      </div>

      <div class="d-flex pt-5 mt-1 justify-content-left">
        <img class="icon-menu" :src="require(`../../assets/ruleGames/main/win_icon.png`)" alt="">
        <div class="m-0 pl-3">
          <span class="m-0 text-bold">{{ $t('main-game.winning') }}</span>
          <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t('main-game.winning-des1') }}</div>
          <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t('main-game.winning-des2') }}</div>
        </div>
      </div>

      <div class="d-flex pt-5 mt-1 pl--5 justify-content-left">
        <img class="icon-menu" :src="require(`../../assets/ruleGames/main/quit_icon.png`)" alt="">
        <div class="m-0 pl-3">
          <span class="m-0 text-bold">{{ $t('main-game.quit') }}</span>
          <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t('main-game.text-quit') }}</div>
        </div>
      </div>

      <div class="d-flex pt-5 mt-1 justify-content-left">
        <img class="icon-menu" :src="require(`../../assets/ruleGames/main/info_icon.png`)" alt="">
        <div class="m-0 pl-3">
          <span class="m-0 text-bold">{{ $t('main-game.pay-info') }}</span>
          <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t('main-game.text-info') }}</div>
        </div>
      </div>

      <div class="d-flex pt-5 mt-1 justify-content-left">
        <img class="icon-menu" :src="require(`../../assets/ruleGames/main/history_icon.png`)" alt="">
        <div class="m-0 pl-3">
          <span class="m-0 text-bold">{{ $t('main-game.history') }}</span>
          <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t('main-game.text-history') }}</div>
        </div>
      </div>

      <div class="d-flex pt-5 mt-1 justify-content-left">
        <img class="icon-menu" :src="require(`../../assets/ruleGames/main/option_icon.png`)" alt="">
        <div class="m-0 pl-3">
          <span class="m-0 text-bold">{{ $t('main-game.sound-settings') }}</span>
          <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t('main-game.sound-settings-desc1') }}</div>
        </div>
      </div>

      <div class="d-flex pt-5 mt-1 justify-content-left">
        <img class="icon-menu" :src="require(`../../assets/ruleGames/main/close_icon.png`)" alt="">
        <div class="m-0 pl-3">
          <span class="m-0 text-bold">{{ $t('main-game.close') }}</span>
          <div class="m-0 text-sub pl-4" :class="`-${lang}`">{{ $t('main-game.text-close') }}</div>
        </div>
      </div>

      <div class="p-3"></div>

    </div>
  </div>
</template>

<script>

export default {
  name: 'rule-mafiaways2',
  props: {
    data: Object,
    lang: String,
    imgLang: String,
    betMinMax: Array,
    currentBet: Number,
    currency: String,
    isShowCurrencySymbol: Boolean,
  },
  data() {
    return {
      textList: [
        'mafiaways2.text-rule1',
        'mafiaways2.text-rule2',
        'mafiaways2.text-rule3',
        'mafiaways2.text-rule4',
        'mafiaways2.text-rule6',
        'mafiaways2.text-rule9',
        'mafiaways2.text-rule10',
        'mafiaways2.text-rule11',
        'mafiaways2.text-rule12',
        'mafiaways2.text-rule13',
      ],
      roundList: [
        'mafiaways2.round-des',
        'mafiaways2.round-des1',
        'mafiaways2.round-des2',
        'mafiaways2.round-des3',
        'mafiaways2.round-des4',
        'mafiaways2.round-des5',
        'mafiaways2.round-des6',
        'mafiaways2.round-des7',
        'mafiaways2.round-des8',

      ],
      goldframeList: [
        'mafiaways2.goldframe-desc1',
        'mafiaways2.goldframe-desc2',
        'mafiaways2.goldframe-desc3',
        'mafiaways2.goldframe-desc4',
        'mafiaways2.goldframe-desc5',
      ],
      wildList: [
        'mafiaways2.wildsymbol-desc1',
        'mafiaways2.wildsymbol-desc2',
        'mafiaways2.wildsymbol-desc3',
        'mafiaways2.wildsymbol-desc4',
        'mafiaways2.wildsymbol-desc5',
      ],
      multipliersList: [
        'mafiaways2.multipliers-des1',
        'mafiaways2.multipliers-des2',
        'mafiaways2.multipliers-des3',
        'mafiaways2.multipliers-des4',
        'mafiaways2.multipliers-des5',
      ],
      freespinFeatureList: [
        'mafiaways2.freespin-des1',
        'mafiaways2.freespin-des2',
        'mafiaways2.freespin-des3',
        'mafiaways2.freespin-des4',
        'mafiaways2.freespin-des5',
        'mafiaways2.freespin-des6',
        'mafiaways2.freespin-des7',
      ],
      buyfreespinList: [
        'mafiaways2.buyfreespin-des1',
        'mafiaways2.buyfreespin-des2',
        'mafiaways2.buyfreespin-des3',
        'mafiaways2.buyfreespin-des4',
        'mafiaways2.buyfreespin-des5',
        'mafiaways2.buyfreespin-des7',
        'mafiaways2.buyfreespin-des9',
      ],
      wayList: [
        'mafiaways2.way-des1',
        'mafiaways2.way-des2',
      ],
      spinList: [
        'main-game.spin-des1',
        'main-game.spin-des2',
        'main-game.spin-des3',
        'main-game.spin-des4',
        'main-game.spin-des5',
      ],

      baseBet: this.data.config.baseBet,
      betLevel: this.data.config.betLevel,
      betSize: this.data.config.betSize,
      paytable: this.data.config.payTable
    }
  },
  computed: {
    formattedCurrency() {
      return this.$options.filters.currencySymbol(this.currency);
    }
  },
  methods: {
    currencyFormatterWithSymbol(val) {
      if (this.isShowCurrencySymbol === false) {
        this.currency = '';
      }
      return this.$options.filters.currencyFormatterWithSymbol(val, this.currency);
    },
    decimalFormat(value) {
      value = Math.round((value + Number.EPSILON) * 1000) / 1000;
      return value.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 3 });
    }
  }
}
</script>

<style>
.bg-mafiaways2 {
  background: #240F0F;
}

.nav-mafiaways2 {
  background: #4A0E17;
  border-radius: 30px;
}

.text-title.-mafiaways2 {
  color: #fff;
}

.text-title-bold {
  color: white;
  text-align: center;
  font-size: 5vw;
  font-weight: bold;
}

.text-bold {
  color: white;
  text-align: left;
  font-size: 4vw;
  font-weight: bold;
}


.text-sub-payout {
  font-size: 3vw;
  color: white;
}

.highlight-gray {
  background-color: gray;
  padding: 2px;
  border-radius: 3px;
}

.highlight-red {
  background-color: #4A0E17;
  padding: 2px;
  border-radius: 3px;
}


.icon-info {
  width: 100px;
  height: 100px;
  margin-right: 10px;
}

.icon-spin {
  width: 15%;
  height: 15%;
  margin-right: 10px;
}

.icon-menu {
  width: 15%;
  height: 15%;
  margin-right: 10px;
}

.icon-menu-button {
  width: 20%;
  height: 20%;
  /* margin-right: 10px; */
}

.icon-close {
  width: 12%;
  height: 12%;
  margin-right: 10px;
}

.icon-refresh {
  width: 120px;
  height: 120px;
  padding-left: -20px;
}

.icon-way {
  width: 90%;
  height: 90%;
}

.icon-symbol {
  width: 25vw
}

.icon-paytable {
  width: 90%;
}

@media (min-width: 576px) {

  .container,
  .container-sm,
  .container-md {
    max-width: 720px;
  }
}

@media (min-width: 768px) {

  .container,
  .container-sm,
  .container-md {
    max-width: 920px;
  }
}

@media (min-width: 1024px) {

  .container,
  .container-sm,
  .container-md {
    max-width: 1520px;
  }
}
</style>